define('lib/Frame',[], function () {

    "use strict";

    var linear = function (t) { return t; };

    var start = function (canvas, playOnStart) {
        if (!canvas) {
            window.console.error('No canvas element provided.');
        }

        // initial setup
        this.el = canvas;
        this.ctx = canvas.getContext('2d');

        // keeping the canvas to have correct dimension attrs
        this._onResize = this.onResize.bind(this);
        window.addEventListener('resize', this._onResize);
        this.onResize();
        this.resize();

        // play immediately
        if (playOnStart !== false) {
            this.to();
        }
    };

    var to = function (tDiff, duration, easing) {
        var clock,
            startTime = new Date(),
            from = this.tDiff,
            stop = this.stop.bind(this);
        easing = easing ? easing : linear;

        stop();
        
        // clock function
        if (tDiff === undefined) {
            clock = function () {
                return new Date() - startTime;
            };
        } else if (duration) {
            clock = function () {
                var t = new Date() - startTime;
                if (t >= duration) {
                    stop();
                }
                return easing(t / duration) * (tDiff - from) + from;
            };
        } else {
            // render 1 frame only
            this.tDiff = tDiff;
            this.render(tDiff);
            return;
        }

        // start the rendering loop
        this.status = 1;
        this._frame(clock);

        // fallback for ie9
        if (!window.requestAnimationFrame) {
            this._intvl = setInterval(this._frame.bind(this, clock), 16); // 60fps
        }
    };

    var stop = function () {
        this.status = 0;

        if (this._intvl) {
            clearInterval(this.intvl);
        }
    };

    var _frame = function (tDiffFn) {
        if (!this.status) {
            return;
        }
        this.tDiff = tDiffFn();
        this.render(this.tDiff);
        this.resized = false;
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(this._frame.bind(this, tDiffFn));
        }
    };

    var onResize = function () {
        this.width = this.el.offsetWidth;
        this.height = this.el.offsetHeight;
        this.el.setAttribute('width', this.width);
        this.el.setAttribute('height', this.height);
        this.resized = true;

        // force to rerender if paused
        if (!this.status) {
            this.render(this.tDiff);
        }
    };

    var clear = function () {
        this.ctx.clearRect(0, 0, this.el.offsetWidth, this.el.offsetHeight);
    };

    var render = function (tDiff) {
        if (this.resized) {
            this.resize();
        }

        if (this.removeAt && tDiff > this.removeAt) {
            this.remove();
        }

        this.clear();
        for (var i = 0; i < this.shapes.length; i++) {
            var shape = this.shapes[i];
            if ((shape.insertAt || 0) <= tDiff) {
                var progress = (tDiff - (shape.insertAt || 0)) / (shape.speed || 100);
                progress = progress > 1 ? 1 : progress;
                this.draw(shape, progress);
            }
        }
    };

    var remove = function () {
        this.stop();

        // remove onResize event
        window.removeEventListener('resize', this._onResize);
        this.el.parentNode.removeChild(this.el);
    };

    var Frame = function () {};
    Frame.prototype = {
        resized: false,
        status: 0, // playing or paused?
        tDiff: 0,
        shapes: [],
        start: start,
        stop: stop,
        _frame: _frame,
        onResize: onResize,
        clear: clear,
        render: render,
        draw: function () {},
        resize: function () {},
        to: to,
        remove: remove,
        removeAt: null
    };

    return Frame;

});
